export default __webpack_public_path__ + "static/media/838.2298cdcb.gif";